import React from "react";
import { Link } from "react-router-dom";

import {
  BellIcon,
  CirclesDeco,
  LockIcon,
  MessageIcon,
  RadarChart,
  RadialProgress,
} from "../../assets/icons/icons";

import useOrganization from "../organization/hooks/useOrganization";
import { useProfile } from "./hooks/useProfile";
import teamTrustLogo from "../../assets/images/team-trust-logo.png";

const SignupComplete = () => {
  document.title = `Signup Complete - ${process.env.REACT_APP_NAME}`;

  const { user } = useProfile();
  const { currentOrganization } = useOrganization();

  return (
    <React.Fragment>
      <div className="login-page">
        <div className="login-left">
          <header className="create-account-header">
            <img
              src={currentOrganization?.image ?? teamTrustLogo}
              alt="Good Leadership"
              className="login-logo"
            />
          </header>

          <div className="login-body">
            <div className="login-card max-w-[350px]">
              <h1 className="login-title">
                {user?.first_name},
                <br />
                you’re all set!
              </h1>
              <p className="login-description text-meta text-[12px] md:text-[14px]">
                Nice work! Your account is all setup and ready.
              </p>

              <Link to="/locker-room" className="login-submit">
                Go to your Locker Room
              </Link>

              {/* Footer links */}
              <div className="login-footer-links">
                <p
                  className="text-slate-500 mt-2 font-primary"
                  style={{
                    fontSize: "0.75rem",
                  }}
                >
                  By signing up, you agree to{" "}
                  <Link
                    to="#"
                    className="underline hover:text-blue transition hover:no-underline text-blue"
                  >
                    our communication &amp; usage terms
                  </Link>
                </p>
              </div>
            </div>

            {/* Info text (tablet / mobile only) */}
            <div className="login-info">
              <h2 className="login-info-title">
                Build winning teams,
                <br />
                faster and easier.
              </h2>
              <p className="login-info-text text-dark-blue">
                Thrive and win together.
              </p>
            </div>
          </div>

          {/* Desktop footer */}
          <footer className="login-desktop-footer">
            <p
              className="text-slate-500 font-primary"
              style={{ fontSize: "0.75rem" }}
            >
              By signing up, you agree to{" "}
              <Link
                to="#"
                className="underline hover:text-blue transition hover:no-underline text-blue"
              >
                our communication &amp; usage terms
              </Link>
            </p>
          </footer>
        </div>

        <div className="login-right">
          <CirclesDeco />

          <div
            className="relative mx-auto w-full px-4 py-11"
            style={{ maxWidth: 786 }}
          >
            <div
              className="relative mx-auto"
              style={{ maxWidth: 525, paddingTop: 77 }}
            >
              {/* Floating icon — Message */}
              <div
                className="absolute flex items-center justify-center rounded-full bg-white z-10"
                style={{
                  top: 0,
                  left: 147,
                  width: 70,
                  height: 70,
                  fontSize: 70,
                  boxShadow: "0 10px 40px 0 rgba(0,0,0,0.1)",
                }}
              >
                <MessageIcon className="text-dark-blue" />
              </div>

              {/* Floating icon — Bell */}
              <div
                className="absolute flex items-center justify-center rounded-full bg-white z-10"
                style={{
                  top: 107,
                  left: -15,
                  width: 101,
                  height: 101,
                  fontSize: 101,
                  boxShadow: "0 10px 40px 0 rgba(0,0,0,0.1)",
                }}
              >
                <BellIcon className="text-dark-blue" />
              </div>

              {/* Floating icon — Lock */}
              <div
                className="absolute flex items-center justify-center rounded-full bg-white z-10"
                style={{
                  bottom: 13,
                  right: 59,
                  width: 72,
                  height: 72,
                  fontSize: 72,
                  boxShadow: "0 10px 40px 0 rgba(0,0,0,0.1)",
                }}
              >
                <LockIcon className="text-dark-blue" />
              </div>

              {/* Radial progress */}
              <div
                style={{
                  position: "relative",
                  marginLeft: "auto",
                  maxWidth: 272,
                  zIndex: 3,
                  paddingBottom: 49,
                }}
              >
                <RadialProgress />
              </div>

              {/* Radar chart card */}
              <div
                className="relative bg-white"
                style={{
                  marginTop: -92,
                  maxWidth: 301,
                  zIndex: 2,
                  boxShadow: "0 10px 40px 0 rgba(0,0,0,0.1)",
                }}
              >
                <div
                  style={{
                    position: "relative",
                    paddingTop: `${(233 / 301) * 100}%`,
                  }}
                >
                  <div className="absolute inset-0 flex items-center justify-center p-3">
                    <RadarChart />
                  </div>
                </div>
              </div>
            </div>

            {/* Tagline */}
            <div
              className="relative mx-auto text-center px-4"
              style={{ marginTop: 77, maxWidth: 400, zIndex: 1 }}
            >
              <h2
                className="font-bold text-dark-blue leading-snug mb-6"
                style={{ fontSize: 35, fontFamily: "var(--font-primary)" }}
              >
                Build winning teams,
                <br />
                faster and easier.
              </h2>
              <p
                className="text-dark-blue"
                style={{ fontSize: 18, fontFamily: "var(--font-primary)" }}
              >
                Thrive and win together.
              </p>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SignupComplete;
